import { beforeEnterEspecialista as beforeEnter } from '@/views/contratos-originacao/especialista/routes/beforeRouter';

const routes = [
    {
        path: '/especialista',
        name: 'Especialistas',
        meta: {
            roles: [
                'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                'ROLE_ADMINISTRATOR'
            ]
        },
        beforeEnter,
        component: () =>
            import(
                '@/views/contratos-originacao/especialista/views/ConfiguracaoEspecialista.vue'
            )
    },
    {
        path: '/especialista/cadastro/:id?',
        name: 'EspecialistaCadastro',
        meta: {
            roles: [
                'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                'ROLE_ADMINISTRATOR'
            ]
        },
        beforeEnter,
        component: () =>
            import(
                '@/views/contratos-originacao/especialista/views/FormularioEspecialista.vue'
            )
    },
    {
        path: '/especialista/edicao/:id',
        name: 'EspecialistaEdicao',
        meta: {
            roles: [
                'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                'ROLE_ADMINISTRATOR'
            ]
        },
        beforeEnter,
        component: () =>
            import(
                '@/views/contratos-originacao/especialista/views/FormularioEspecialista.vue'
            )
    },
    {
        path: '/especialista/detalhes/:id',
        name: 'EspecialistaDetalhes',
        meta: {
            roles: [
                'ROLE_FEATURE_CONFIGURACAO_RASTREABILIDADE',
                'ROLE_ADMINISTRATOR'
            ]
        },
        beforeEnter,
        component: () =>
            import(
                '@/views/contratos-originacao/especialista/views/DetalhesEspecialista.vue'
            )
    }
];

export default routes;
